module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.71dbcad4.png";